import { handlePostRequest } from "../hooks/api";

export async function handlePromotions(payload) {
  const response = await handlePostRequest(
    "/posting/community-promotions",
    payload,
    {},
    false
  );

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
